import React, { useEffect } from "react"
// eslint-disable-next-line no-restricted-imports
import { Container, FlexContainer } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { Box, Link, Typography } from "@carrotfertility/carotene-core"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { IlloCoinsAndBills } from "../../../views/atoms/Illustrations"
import { Steps } from "../../workflow/steps"
import { useEnrollmentFlowModal } from "#/components/cmd-enrollment/EnrollmentModal"
import { FormattedMessage } from "react-intl"
import { BankInfoOptionButtons } from "#/components/cmd-enrollment/shared/BankInfoOptionButtons"
import { useBenefitEnrollment } from "#/components/context/enrollment/BenefitEnrollmentContext"
import { useProgressTracker } from "../../../views/modal/ProgressTracker"
import { useShouldFillOutBankInfo } from "#/components/bank-details/hooks/useGetFundsAdministration"

export function FinalStep(): JSX.Element {
  const { onExit } = useEnrollmentFlowModal()
  useStateMachine(Steps.FINAL, null)
  const needsBankInfo = useShouldFillOutBankInfo()
  const { deductibleFlowType } = useBenefitEnrollment()

  const { showProgress } = useProgressTracker()
  useEffect(showProgress, [showProgress])

  const isEMD = deductibleFlowType === "EXTERNAL"

  return (
    <div>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
        <FlexContainer justifyContent="center" padding="none" stack="large">
          <IlloCoinsAndBills />
        </FlexContainer>
      </Box>
      <Typography
        id="step-heading"
        variant="h2"
        color={(theme) => theme.palette.text.primary}
        paddingBottom={(theme) => theme.tokens.spacing.md}
      >
        <FormattedMessage defaultMessage="You're all set." />
      </Typography>
      <Container padding="none" stack="medium">
        {needsBankInfo?.data && (
          <Typography color={(theme) => theme.palette.text.secondary}>
            <FormattedMessage defaultMessage="We have all the information we need for now." />
          </Typography>
        )}
      </Container>
      <Container padding="none" stack="medium">
        <Typography color={(theme) => theme.palette.text.secondary}>
          {isEMD ? (
            <FormattedMessage
              defaultMessage="To check the status of any deductibles, check your health insurance portal. You can read more about deductibles in your <dBGLink>benefit guide</dBGLink>"
              values={{
                dBGLink: (linkContent) => (
                  <Link color={"inherit"} href="/your-benefit-guide/carrot-funds/deductibles" target="_blank">
                    {linkContent}
                  </Link>
                )
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="To check the status of any deductibles, see the <link>Your funds</link> page. You can read more about deductibles in your <dBGLink>benefit guide</dBGLink>"
              values={{
                link: (linkContent) => (
                  <Link color={"inherit"} href="/transactions" target="_blank">
                    {linkContent}
                  </Link>
                ),
                dBGLink: (linkContent) => (
                  <Link color={"inherit"} href="/your-benefit-guide/carrot-funds/deductibles" target="_blank">
                    {linkContent}
                  </Link>
                )
              }}
            />
          )}
        </Typography>
      </Container>
      <BankInfoOptionButtons {...{ onExit }} />
    </div>
  )
}

export function FinalNoDeductibleStep(): JSX.Element {
  const { onExit } = useEnrollmentFlowModal()
  useStateMachine(Steps.FINAL_NO_DEDUCTIBLE, null)

  return (
    <div>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
        <FlexContainer justifyContent="center" padding="none" stack="large">
          <IlloCoinsAndBills />
        </FlexContainer>
      </Box>
      <Typography
        id="step-heading"
        variant="h2"
        color={(theme) => theme.palette.text.primary}
        paddingBottom={(theme) => theme.tokens.spacing.md}
      >
        <FormattedMessage defaultMessage="You're all set." />
      </Typography>
      <Container padding="none" stack="medium">
        <Typography color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage defaultMessage="We have all the information we need for now." />
        </Typography>
      </Container>
      <Container padding="none" stack="medium">
        <Typography color={(theme) => theme.palette.text.secondary}>
          <FormattedMessage defaultMessage="It looks like you do not have a deductible associated with your Carrot benefit. That means we can start reimbursing eligible expenses right away." />
        </Typography>
      </Container>
      <BankInfoOptionButtons {...{ onExit }} />
    </div>
  )
}
